module.exports = __webpack_public_path__ + "static/TTNormsPro-Regular-00873838ae3e2bd8924cc38394475a3f.woff";